import React from "react";
import PropTypes from "prop-types";

const StoriesAndSignalsIllustration = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 292 292"
      fill={props.fill}
      style={props.style}
    >
      <rect width={props.width} height={props.height} fill="#F5F5FF" />
      <path
        d="M228.612 140.342L253.15 137.628L243.098 159.141L228.612 140.342Z"
        fill="#F76E88"
      />
      <path
        d="M252.986 137.743L234.535 147.968L234.747 154.319L236.732 150.591L252.986 137.743Z"
        fill="#D75674"
      />
      <path
        d="M236.734 150.591L234.749 154.319L238.331 152.929L236.734 150.591Z"
        fill="#B04464"
      />
      <path
        d="M46.2366 151.764C46.2366 151.764 38.2826 168.853 37.034 172.596C35.7855 176.339 31.0946 184.091 43.7394 187.986L55.4901 174.41L62.8649 162.489L46.2366 151.764Z"
        fill="#EEAF7C"
      />
      <path
        d="M113.243 66.6523C120.136 78.3514 118.461 91.2993 121.781 103.04C124.949 114.244 129.651 125.338 129.651 125.338C129.651 125.338 90.8499 137.435 76.5998 135.322C62.3498 133.208 59.8221 126.154 59.8221 126.154C62.5993 120.741 63.0775 114.013 64.7234 106.881C69.2964 87.0643 65.541 74.2726 80.0846 61.3438C89.9593 52.5654 106.35 54.9532 113.243 66.6523Z"
        fill="#855900"
      />
      <path
        d="M71.5229 122.9C71.5229 122.9 69.7135 123.297 67.6112 123.916C65.5089 124.536 57.8673 126.529 55.9985 127.795C54.1296 129.062 51.8594 132.493 51.0123 134.122C50.1652 135.751 47.7965 141.063 46.5255 143.229C45.2545 145.394 41.2985 150.88 41.7039 151.547C42.1092 152.214 48.0225 157.979 50.5035 160.635C53.9572 164.047 58.5993 165.987 63.4538 166.047C63.5653 169.624 64.0412 173.181 64.8742 176.662C66.2883 182.787 67.0994 198.762 66.595 206.822C66.0906 214.881 63.6942 236.473 63.6942 236.473L142.564 236.362C140.918 233.475 139.994 230.233 139.871 226.912C139.478 220.906 136.142 213.883 134.477 209.275C132.812 204.666 135.237 203.53 133.187 198.285C131.138 193.04 134.171 178.364 133.802 174.755C133.432 171.146 132.074 161.117 132.074 161.117L141.169 157.353C141.169 157.353 151.992 146.033 153.691 138.811C153.691 138.811 137.13 125.78 135.42 124.853C133.71 123.925 131.057 121.117 127.518 120.971C123.978 120.824 115.383 120.674 115.383 120.674L82.3258 125.665L71.5229 122.9Z"
        fill="#A3A3F5"
      />
      <path
        d="M105.901 106.686C105.901 106.686 105.96 112.682 107.036 115.643C108.112 118.604 115.375 120.687 115.375 120.687L113.449 124.805C113.449 124.805 107.934 136.178 95.4481 137.187C79.7467 138.453 71.5245 122.892 71.5245 122.892L77.6692 120.69C77.6692 120.69 82.7221 118.66 82.5511 112.078C82.38 105.496 80.9514 96.2153 80.9514 96.2153L105.901 106.686Z"
        fill="#EEAF7C"
      />
      <path
        d="M81.8963 103.054L106.164 110.637C102.119 118.727 94.03 117.715 90.491 114.682C87.6598 112.255 82.4018 106.93 81.8963 103.054Z"
        fill="#D1905E"
      />
      <path
        d="M108.693 70.696C108.693 70.696 112.827 76.6925 112.836 82.8301C112.844 88.9678 114.123 92.4146 112.836 97.826C111.55 103.237 107.105 113.284 99.714 113.902C92.3233 114.519 83.202 106.725 81.6083 102.339C80.0147 97.953 75.2886 80.6993 78.4683 76.8323C81.648 72.9652 100.827 63.6594 108.693 70.696Z"
        fill="#EEAF7C"
      />
      <path
        d="M132.063 161.138C132.063 161.138 132.62 154.514 132.487 153.553C132.354 152.593 128.659 142.618 128.333 140.829C128.007 139.039 127.434 133.701 127.434 133.701C127.434 133.701 126.436 143.511 127.067 146.119C127.697 148.727 129.938 152.799 130.265 155.154C130.67 157.202 131.272 159.206 132.063 161.138Z"
        fill="#8888F2"
      />
      <path
        d="M109.233 67.8226C106.55 68.1875 104.091 69.5131 102.312 71.5534C100.03 73.9732 93.0003 86.8753 79.0082 88.4824L73.431 84.3546C73.431 84.3546 73.665 70.906 84.6476 64.8237C94.2864 59.4713 104.026 61.2575 109.233 67.8226Z"
        fill="#855900"
      />
      <path
        d="M79.008 88.4812C79.008 88.4812 76.4641 84.2683 74.1385 84.2311C71.8128 84.1939 71.8076 87.7228 72.5892 89.8654C73.8878 92.7719 75.5717 95.4903 77.5956 97.9475C78.6081 98.8865 81.034 98.2663 80.9515 97.1238C80.869 95.9813 79.008 88.4812 79.008 88.4812Z"
        fill="#EEAF7C"
      />
      <path
        d="M74.5886 87.6894C76.4156 89.2186 77.8415 91.1708 78.7424 93.3764L76.1534 93.0362L77.1634 92.2461L74.5886 87.6894Z"
        fill="#D1905E"
      />
      <path
        d="M87.9947 179.271C87.9947 179.271 103.156 175.205 109.222 174.327C115.288 173.449 133.283 185.416 131.636 186.692C131.095 187.058 130.47 187.281 129.819 187.34C129.169 187.399 128.514 187.293 127.916 187.031C127.916 187.031 128.718 189.518 124.015 188.503C124.015 188.503 123.005 189.738 119.526 189.308C119.526 189.308 119.396 190.249 115.877 189.778C113.435 189.397 111.055 188.696 108.796 187.695C107.499 187.653 106.203 187.767 104.934 188.034C103.428 188.461 93.6428 190.639 88.1996 188.341C88.1996 188.341 76.2502 190.046 55.471 189.954C44.9448 189.908 30.4152 190.262 34.8277 178.668C38.8071 168.238 46.5451 170.168 55.3573 173.766C65.7501 177.797 76.8547 179.67 87.9947 179.271Z"
        fill="#EEAF7C"
      />
      <path
        d="M125.327 187.034C125.327 187.034 116.773 180.231 110.42 178.218"
        stroke="#D1905E"
        strokeWidth="0.778584"
        strokeMiterlimit="10"
      />
      <path
        d="M121.425 188.504C117.689 185.026 113.256 182.382 108.421 180.746"
        stroke="#D1905E"
        strokeWidth="0.778584"
        strokeMiterlimit="10"
      />
      <path
        d="M116.937 189.312C116.937 189.312 108.568 184.52 106.756 183.684"
        stroke="#D1905E"
        strokeWidth="0.778584"
        strokeMiterlimit="10"
      />
      <path
        d="M55.772 173.955C51.9563 171.971 47.5676 171.38 43.3628 172.284L55.772 173.955Z"
        fill="#D1905E"
      />
      <rect
        width="21.2237"
        height="41.3304"
        rx="2.09908"
        transform="matrix(-0.916812 -0.399319 -0.399319 0.916812 158.745 110.518)"
        fill="#484848"
      />
      <circle
        cx="1.67556"
        cy="1.67556"
        r="1.67556"
        transform="matrix(-0.916812 -0.399319 -0.399319 0.916812 154.336 112.254)"
        fill="#D9D9D9"
      />
      <path
        d="M131.543 163.344C131.543 163.344 137.456 183.366 138.311 187.238C139.165 191.109 141.536 201.389 143.908 205.36C146.279 209.33 149.866 214.886 154.395 214.213C158.924 213.539 160.33 206.368 160.235 203.254C160.139 200.14 161.355 194.566 158.705 187.017C156.056 179.467 148.861 154.3 148.737 152.369C148.613 150.438 149.147 141.438 149.872 139.627C150.598 137.816 151.433 135.266 150.167 133.337C148.9 131.407 144.826 125.255 143.664 125.257C142.501 125.258 136.003 127.927 135.185 129.04C134.661 129.94 134.384 130.963 134.381 132.004C134.381 132.004 131.959 135.9 132.486 136.8C131.951 137.395 131.577 138.117 131.401 138.899C131.225 139.68 131.253 140.493 131.482 141.26C130.916 142.37 130.529 143.561 130.334 144.791C130.396 145.802 133.089 148.427 135.223 148.566C135.223 148.566 134.131 155.544 137.52 157.157L131.195 160.321L131.543 163.344Z"
        fill="#EEAF7C"
      />
      <path
        d="M137.549 157.269C137.549 157.269 138.824 165.457 139.995 171.027C141.165 176.597 142.41 184.654 142.182 187.991C141.954 191.328 142.195 196.667 142.195 196.667C141.569 192.622 141.256 188.536 141.257 184.443C141.483 179.357 137.549 157.269 137.549 157.269Z"
        fill="#D1905E"
      />
      <path
        d="M143.291 134.005C143.291 134.005 142.083 130.852 141.477 130.711C140.87 130.571 138.384 131.959 138.384 131.959L143.291 134.005Z"
        fill="#D1905E"
      />
      <path
        d="M142.287 139.061C142.287 139.061 134.599 136.484 134.194 136.423C133.606 136.487 133.03 136.638 132.486 136.871"
        stroke="#D1905E"
        strokeWidth="0.283121"
        strokeMiterlimit="10"
      />
      <path
        d="M138.384 131.989C138.384 131.989 136.27 131.395 135.896 131.325C135.521 131.255 134.38 132.055 134.38 132.055"
        stroke="#D1905E"
        strokeWidth="0.283121"
        strokeMiterlimit="10"
      />
      <path
        d="M139.906 143.392C139.906 143.392 132.904 140.48 131.5 141.321"
        stroke="#D1905E"
        strokeWidth="0.283121"
        strokeMiterlimit="10"
      />
      <path
        d="M135.252 148.629C135.011 147.718 134.671 146.837 134.237 146.001C133.858 145.86 133.47 145.749 133.074 145.669C133.074 145.669 134.857 148.265 135.252 148.629Z"
        fill="#D1905E"
      />
      <path
        d="M63.4559 166.07C63.4559 166.07 63.3044 158.992 62.4316 156.708C61.5588 154.424 59.3774 141.909 59.3774 141.909C59.3774 141.909 58.2905 152.72 59.6816 156.864C60.5265 159.842 60.8018 162.953 60.4932 166.034L63.4559 166.07Z"
        fill="#8888F2"
      />
      <path
        d="M129.106 124.5C126.586 126.619 102.943 145.995 111.17 157.911C115.402 164.75 140.877 168.27 162.256 155.175C183.635 142.08 208.486 131.658 203.009 151.953C197.531 172.248 220.609 166.29 234.038 155.175M152.306 107.412C166.208 100.32 181.244 98.3336 184.648 103.44C188.053 108.547 184.648 130.392 136.134 151.953C132.076 153.757 129.042 152.52 134.716 148.265"
        stroke="#FF8DA6"
        strokeWidth="0.545452"
      />
    </svg>
  );
};

StoriesAndSignalsIllustration.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  style: PropTypes.object,
  fill: PropTypes.string,
};

StoriesAndSignalsIllustration.defaultProps = {
  width: 292,
  height: 292,
  fill: "none",
  style: {},
};

export default StoriesAndSignalsIllustration;
